<script setup lang="ts">
import { dismissToast, toasts, type Toast } from './toast';

function colourClass(type: Toast['type']) {
  return {
    success: 'bg-green-600',
    error: 'bg-red-600',
    info: 'bg-primary-600',
  }[type];
}
</script>

<template>
  <div
    aria-live="polite"
    aria-atomic="false"
    class="fixed bottom-4 right-4 z-50 flex flex-col gap-2"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      role="alert"
      :class="['flex items-center gap-3 rounded-lg px-4 py-3 text-white shadow-lg text-sm', colourClass(toast.type)]"
    >
      <span>{{ toast.message }}</span>
      <button
        @click="dismissToast(toast.id)"
        class="ml-2 text-white/80 hover:text-white"
        aria-label="Dismiss notification"
      >✕</button>
    </div>
  </div>
</template>
